var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.title,"value":true},on:{"close-modal":_vm.closeModal}},[_c('action-form',{attrs:{"action-id":_vm.id,"code-project":_vm.codeProject}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0390c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/actions/page-action-new.vue
// module id = 907
// module chunks = 3